module.exports = __webpack_public_path__ + "static/media/tinkybart.1e564a49.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/tinkybart.webp
// module id = 447
// module chunks = 0